<template>
  <v-select v-model="selectedId" :items="userItems"
            :label="label" :disabled="disabled"
            item-text="name" item-value="id"
            v-bind="$attrs">
  </v-select>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'UserSelect',
  props: {
    value: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: 'User'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['users']),
    selectedId: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },
    userItems() {
      const active = this.users.filter(u => u.active)
      const admins = active.filter(u => u.admin >= 1)
      const others = active.filter(u => !u.admin)
      if (admins.length === 0 || others.length === 0) return active
      return [
        { header: 'Admin' },
        ...admins,
        { divider: true },
        { header: 'Other' },
        ...others
      ]
    }
  },
  created() {
    this.$store.dispatch('getUsers')
  }
}
</script>
